<!-- nav -->
<mat-toolbar class="wrap">
  <!-- left -->
  <div id="menu-icons">
    @if (!isNavigationDisabled) {
      <button mat-icon-button color="primary" (click)="onClickMenuBtn()">
        <mat-icon>{{ (menuOpened$ | async) ? 'close' : 'menu' }}</mat-icon>
      </button>
    }

    @if (!hideMenu) {
      <app-main-menu-list [theme]="'row'"></app-main-menu-list>
    }
  </div>

  <!-- logo -->
  <a [routerLink]="logoPath" id="logo"><img [src]="logo" alt="EEMO Logo" /></a>

  <!-- right -->
  <div class="right-menu">
    <app-main-menu-right></app-main-menu-right>
  </div>
</mat-toolbar>
